var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1980,
    height: 2394,
    viewBox: "0 0 1980 2394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2392.9 0.00158691C2670.37 277.399 2859.32 630.825 2935.88 1015.59C3012.43 1400.35 2973.14 1799.16 2822.98 2161.6C2672.81 2524.04 2418.52 2833.82 2092.25 3051.77C1765.98 3269.72 1382.4 3386.05 989.999 3386.05C597.601 3386.05 214.014 3269.72 -112.253 3051.77C-438.52 2833.82 -692.814 2524.04 -842.978 2161.6C-993.142 1799.16 -1032.43 1400.35 -955.878 1015.58C-879.324 630.823 -690.366 277.397 -412.898 0L503.572 916.241C772.238 1184.84 1207.76 1184.84 1476.43 916.242L2392.9 0.00158691Z",
    fill: "url(#paint0_radial_652_1567)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_652_1567",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(990 1121) rotate(90) scale(2265.05 2265.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1773,
    stopColor: "#33CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414611,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.9e385589d265ce26173c7525b7ea3001.svg";
export { ForwardRef as ReactComponent };